import React from 'react'
import IconWrapper from './styles'

export const IconPowerBI = () => {
  return (
    <IconWrapper className='anticon anticon-column-width'>
      <svg
        fill='currentColor'
        viewBox='0 0 1600 1600'
        xmlns='http://www.w3.org/2000/svg'
        focusable='false'
        data-icon='my-icon'
        width='1em'
        height='1em'
        aria-hidden='true'
      >
        <path
          d='m 907.85742,11.962891 c -60.5369,0 -110.66406,50.125216 -110.66406,110.662109 V 380.4375 H 685.08594 607.77539 c -60.49466,0 -110.58594,50.09127 -110.58594,110.58594 V 751.66406 H 307.7793 c -60.49466,0 -110.58594,50.09128 -110.58594,110.58594 v 615.8535 c 0,60.8174 52.03844,108.9082 110.92187,108.9082 h 446.4961 a 49.0049,49.0049 0 0 0 1.79883,-0.033 h 294.19334 a 49,49 0 0 0 2.9668,0.09 h 238.5684 c 59.6288,0 111.1367,-48.7169 111.1367,-109.7129 V 122.625 c 0,-60.532405 -50.1243,-110.662109 -110.6621,-110.662109 z m 0,97.999999 h 384.75588 c 7.5819,0 12.6621,5.0837 12.6621,12.66211 v 1354.7305 c 0,7.1053 -4.6644,11.7129 -13.1367,11.7129 H 1103.2715 V 491.02344 c 0,-60.49646 -50.095,-110.58594 -110.58986,-110.58594 H 895.19336 V 122.625 c 0,-7.57374 5.09029,-12.66211 12.66406,-12.66211 z M 607.77539,478.4375 h 77.31055 307.5957 c 7.53276,0 12.58986,5.05676 12.58986,12.58594 V 1488.9785 H 803.58789 l -0.3125,-626.75389 C 803.24552,801.75917 753.18411,751.66406 692.68945,751.66406 h -97.5 V 491.02344 c 0,-7.53098 5.05496,-12.58594 12.58594,-12.58594 z M 307.7793,849.66406 h 384.91015 c 7.531,0 12.58221,5.04918 12.58594,12.60938 l 0.3125,626.73826 H 308.11523 c -9.1422,0 -12.92187,-3.6986 -12.92187,-10.9082 V 862.25 c 0,-7.53098 5.05495,-12.58594 12.58594,-12.58594 z'
        />
      </svg>
    </IconWrapper>
  )
}
